import React, { useContext } from "react";
// import { useInternalPaths } from "../hooks/useInternalPaths";
import { LayoutContext, constants } from "./LayoutContext";
import { FooterFeaturedLocations } from "./FooterFeaturedLocations";
import { FooterWebsiteInfo } from "./FooterWebsiteInfo";

import "./Footer.css";

const Footer = React.memo(({ i18n, pagePath }) => {
  const layoutContext = useContext(LayoutContext);

  const { theme } = layoutContext;
  false &&
    console.dir({
      FROM: "__debug [Footer] 😁 😁 😁 😁 😁 😁 😁",
    });
  return (
    <footer
      className={theme === constants.THEME_LIGHT ? "theme-light" : "theme-dark"}
      id="footer"
    >
      <div id="footer-left-side"></div>
      <div id="footer-right-side"></div>
      <div id="footer-center">
        <div id="footer-data">
          {/* VERY IMPORTANT INDICATOR - DO NOT DELETE */}
          {/* <pre>
            {JSON.stringify({
              theme: theme,
              pagePath: pagePath,
            })}
          </pre> */}
        </div>

        <div id="footer-links " aria-label="Featured Items">
          <FooterFeaturedLocations i18n={i18n} pagePath={pagePath} />
        </div>

        <div id="footer-links-website-info" aria-label="Website Information">
          <FooterWebsiteInfo i18n={i18n} />
        </div>
      </div>
    </footer>
  );
});

export { Footer };
